export default __webpack_public_path__ + "static/media/pitikCry.c4fce73a.png";